"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
require("./popup.scss");
class PopupMenu extends React.Component {
    mouseIn;
    mounted;
    constructor(props) {
        super(props);
        this.state = { showMenu: false };
        this.mouseIn = false;
        this.mounted = false;
    }
    componentWillMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    showMenu = () => {
        this.onMouseIn();
        this.setState({ showMenu: true });
    };
    onMouseIn = () => {
        this.mouseIn = true;
    };
    onMouseOut = () => {
        this.mouseIn = false;
    };
    hideMenu = () => {
        this.onMouseOut();
        window.setTimeout(this.checkMenu, 300);
    };
    checkMenu = () => {
        if (!this.mouseIn && this.mounted) {
            this.setState({ showMenu: false }, this.props.onHide);
        }
    };
    click = (e) => {
        e.stopPropagation();
        this.hideMenu();
    };
    render() {
        const { children, title, className } = this.props;
        const { showMenu } = this.state;
        return (React.createElement("div", { role: "button", onClick: this.click, className: 'Popup ' + (className || ''), onMouseOver: this.showMenu, onMouseOut: this.hideMenu },
            React.createElement("div", { className: "Popup-toggle" }, title),
            showMenu && (React.createElement("div", { className: "Popup-container Popup-container--down Popup-container--right", onMouseOver: this.onMouseIn, onMouseOut: this.hideMenu },
                React.createElement("div", { className: "Popup-content", role: "list" }, children)))));
    }
}
exports.default = PopupMenu;
